import TitleDesktop from "./block-title-desktop";

export default TitleDesktop;